// store.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

// سلایس‌ها
import belanceReducer from './belanceSlice';
import customerReducer from './customerSlice';
import moneyReducer from './moneysSlice';
import itemReducer from './itemSlice';
import settingReducer from './settingSlice';
import stockReducer from './stockSlice';
import userReducer from './userSlice';
import sidebarReducer from './sidebarSlice';
import tailorReducer from './tailorSlice';
import expenseCategoryReducer from './expenseCategorySlice'; // ✅ اضافه شده

// پیکربندی Persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'belances',
    'customers',
    'moneys',
    'items',
    'settings',
    'stocks',
    'users',
    'sidebars',
    'tailors',
    'expenseCategories' // ✅ اضافه شده
  ],
};

// تمام ریدوسرهای خام
const reducers = {
  belances: belanceReducer,
  customers: customerReducer,
  moneys: moneyReducer,
  items: itemReducer,
  settings: settingReducer,
  stocks: stockReducer,
  users: userReducer,
  sidebars: sidebarReducer,
  tailors: tailorReducer,
  expenseCategories: expenseCategoryReducer, // ✅ اضافه شده
};

// تمام ریدوسرها را به‌صورت داینامیک Persist می‌کنیم
const persistedReducers = Object.keys(reducers).reduce((acc, key) => {
  acc[key] = persistReducer({ ...persistConfig, key }, reducers[key]);
  return acc;
}, {});

// ساخت استور
const store = configureStore({
  reducer: persistedReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // برای اجتناب از هشدار persist
    }).concat(thunk),
});

// persistor
const persistor = persistStore(store);

export { store, persistor };